import { PageBuilderLive } from './PageBuilderLive';
import { PageSanityContentProps } from './interface';

export const PageSanityContent = ({ cms, shouldUseVariation }: PageSanityContentProps) => {
  return <PageBuilderLive cms={cms} shouldUseVariation={shouldUseVariation} />;
};
